module.exports = __webpack_public_path__ + "img/viewicon.d31c6916.svg";